import { render, staticRenderFns } from "./BranchesList.vue?vue&type=template&id=dd2306fa&"
import script from "./BranchesList.js?vue&type=script&lang=js&"
export * from "./BranchesList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports